<template>
  <div class="columns is-multiline mgb-3">
    <section
      v-if="contrat.typeIndexation === constantes.TYPE_INDEXATION_POURCENTAGE"
      class="column is-12">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('detailContrat.indexation.popUpIndexation.dateIndexation')">
            <b-datepicker
              v-model="payload.dateIndexation"
              icon="calendar-today"
              position="is-bottom-right"
              nearby-selectable-month-days
              show-week-number
              editable
            />
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailContrat.indexation.valeurIndexationPourcentage')">
            <input-currency
              v-model="payload.valeurIndexationActuel"
              isNumber="true"
            />
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailContrat.indexation.montantLoyerIndexe')">
            <input-currency
              v-model="montantLoyerIndexe"
              isNumber="true"
              disabled
            />
          </b-field>
        </div>
      </div>
    </section>
    <section
      v-if="contrat.typeIndexation === constantes.TYPE_INDEXATION_INDICE"
      class="column is-12">
      <div class="columns is-multiline">
        <div class="column is-12 is-paddingless">
          <indexation-valeur
            :label="$t('ajoutEditContrat.indexation.valeurActuelle')"
            :valeur.sync="payload.valeurIndexationActuel"
            :date.sync="payload.dateIndexationActuel"
            :indiceSelected="payload.indiceSelected"
          />
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailContrat.indexation.popUpIndexation.dateIndexation')">
            <b-datepicker
              v-model="payload.dateIndexation"
              icon="calendar-today"
              position="is-bottom-right"
              nearby-selectable-month-days
              show-week-number
              editable
            />
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailContrat.indexation.montantLoyerIndexe')">
            <input-currency
              v-model="montantLoyerIndexe"
              isNumber="true"
              disabled
            />
          </b-field>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import inputCurrency from '@/components/general/inputCurrency';
import indexationValeur from '@/components/baux/contrat/componentEdition/indexationValeur';
import {
  TYPE_INDEXATION_INDICE,
  TYPE_INDEXATION_POURCENTAGE,
} from '@/configuration/baux/contrat/contratConf';
import calculMontantIndexe from '@/services/baux/contrat/indexation';
import calculArrondi from '@/services/calcul/calculArrondi';

export default {
  props: {
    contrat: {
      type: Object,
      required: true,
    },
    payload: {
      type: Object,
      required: true,
    },
    indiceEtValeurs: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    inputCurrency,
    indexationValeur,
  },
  data() {
    return {
      constantes: {
        TYPE_INDEXATION_INDICE,
        TYPE_INDEXATION_POURCENTAGE,
      },
    };
  },
  computed: {
    montantLoyerIndexe() {
      const contrat = cloneDeep(this.contrat);
      contrat.valeurIndexationActuel = this.payload.valeurIndexationActuel;
      return calculArrondi(calculMontantIndexe(contrat, contrat.loyerAnnuelHt));
    },
  },
};
</script>
